import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from 'react-router';
import useAppContext from '../../../../hooks/context/useAppContext';
import { useIntl } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: '#ffffff',
    color: theme.palette.primary.main,
  },
}));

const TopBar = () => {
  const classes = useStyles({});
  const { breadCrumbs, backNavigation } = useAppContext();
  const history = useHistory();
  const intl = useIntl();

  return (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label={intl.formatMessage({ id: 'app.buttons.back' })}
          onClick={() => {
            backNavigation ? history.push(backNavigation) : history.goBack();
          }}>
          <ArrowBackIcon aria-hidden="true" />
        </IconButton>
        {breadCrumbs || ''}
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {};

export default TopBar;
